import { Navigate, useNavigate } from "react-router-dom";

import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui";
import { Logo } from "@/components/logo";
import { PolicyFooter } from "@/components/policy-footer";

export default function Landing() {
  const navigate = useNavigate();
  const { status } = useAuth();
  if (status === "authed") return <Navigate to="/" replace />;

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#2A2727]" data-testid="landing-screen">
      <img src="/images/landing.jpg" alt="" className="absolute inset-0 h-full w-full object-cover md:left-auto md:w-[62%]" />
      <div className="absolute inset-0 bg-gradient-to-b from-[rgba(42,39,39,0)] via-[rgba(42,39,39,0.82)] to-[#2A2727] md:bg-gradient-to-r md:from-[#2A2727] md:via-[rgba(42,39,39,0.92)] md:to-[rgba(42,39,39,0.05)]" />
      <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[rgba(42,39,39,0.82)] to-transparent md:hidden" />
      <div className="relative mx-auto flex min-h-screen max-w-6xl flex-col px-6 py-6 md:px-10">
        <header className="flex items-center justify-between">
          <Logo inverse />
          <button data-testid="landing-login-link" onClick={() => navigate("/login")} className="hidden h-10 rounded-full px-4 text-sm font-bold text-[#FDFBF7] hover:bg-white/10 md:block">Log in</button>
        </header>
        <div className="flex flex-1 flex-col justify-end pb-6 md:max-w-xl md:justify-center md:pb-0">
          <p className="fade-up mb-3 text-xs font-bold uppercase tracking-[1.6px] text-[#D48D93]">Connect with Purpose. Find Your Match.</p>
          <h1 data-testid="landing-headline" className="fade-up text-[42px] leading-[1.08] text-[#FDFBF7] [animation-delay:100ms] md:text-[64px]">
            Your Next Meaningful Connection Starts Here.
          </h1>
          <p className="fade-up mt-4 text-base leading-6 text-[#FDFBF7]/90 [animation-delay:200ms] md:text-lg md:leading-7">
            Whether you are looking for marriage, dating, or lighthearted, respectful connection, LOVE NET helps you discover compatible adults and connect on your terms.
          </p>
          <div className="fade-up mt-8 flex flex-col gap-3 [animation-delay:300ms] sm:flex-row">
            <Button testId="landing-join-button" title="Join LOVE NET" onClick={() => navigate("/register")} className="sm:px-8" />
            <Button testId="landing-find-match-button" title="Find Your Match" variant="outline" onClick={() => navigate("/login")} className="border-[#FDFBF7] bg-transparent text-[#FDFBF7] hover:bg-white/10 sm:px-8" />
          </div>
          <p className="mt-4 text-center text-xs text-[#FDFBF7]/70 sm:text-left">For adults 18+ only</p>
        </div>
        <PolicyFooter inverse prefix="landing-footer" />
      </div>
    </div>
  );
}
